<template lang="pug">
    div(v-if="!isHidden" class="mb-3")
        //- select and is-disabled are in forms.stl
        div(class="select" :class="{'is-disabled' : drill.isDisabled}")
            select(
                :disabled="drill.isDisabled"
                v-model="selectedValue"
                @change="changedNative"
                :aria-label="drill.options[0].text"
                class="capitalize"
                :class="selectClass"
            )
                option(
                    v-for="option in drill.options"
                    :value="option.value"
                    :disabled="option.isDisabled"
                    v-html="option.text"
                )
</template>

<script>
/* eslint-disable eqeqeq */
export default {
    name: 'Drill',
    props: {
        drill: {
            type: Object,
            required: true,
        },
        currentValue: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        return {
            hasBadAutoSelect: false,
        }
    },
    computed: {
        selectedValue: {
            get() {
                return this.currentValue
            },
            set(value) {
                this.$emit('changed', {
                    sourceDrillType: this.drill.type,
                    newValue: value,
                    groupValue: this.drill.groupValue,
                    hasBadAutoSelect: this.hasBadAutoSelect,
                })
                // ok we told them, reset for future hits of this instance
                this.hasBadAutoSelect = false
            },
        },
        selectClass() {
            return {
                '-needsSelection': this.currentValue == -1 && !this.drill.isDisabled,
                '-hasSelection': this.currentValue != -1 && !this.drill.isDisabled,
            }
        },
        // if this is a Notes drill and you don't have a real selection, don't show it
        isHidden() {
            return (
                this.drill.type === 'notes' &&
                (this.drill.isDisabled ||
                    (this.drill.options.length == 2 &&
                        this.drill.options[1].text == 'All Submodels'))
            )
        },
    },
    watch: {
        'drill.options'(newVal, oldVal) {
            this.tryAutoSelectNonFitment(newVal)
            this.tryAutoSelectFitment(newVal)
        },
    },
    // in some cases drills get mounted after they already have their auto selected data from vuex, so test for that here.  it was spotty, but enough for concern
    mounted() {
        this.tryAutoSelectFitment(this.drill.options)
        this.tryAutoSelectNonFitment(this.drill.options)
    },
    methods: {
        // let the currentValue get filled by the current tick, then launch this after to make sure the current values are all current
        changedNative() {
            this.$nextTick(function () {
                this.$emit('changedNative', {
                    sourceDrillType: this.drill.type,
                    groupValue: this.drill.groupValue,
                })
                this.$uiEvents.$emit('fitmentChanged', {
                    sourceType: this.drill.type,
                    newValue: this.drill.currentValue,
                    layoutPosition: 'Drilldown',
                })
            })
        },
        // auto-selects based on only 1 option
        tryAutoSelectNonFitment(options) {
            if (this.drill.isFitment || options.length != 2) return

            this.selectedValue = options[1].value
        },
        // auto-selects based on currentValue already being set
        tryAutoSelectFitment(options) {
            // a) this thing is supposed to be for fitment
            // b) because if you visit a product line with a split then go to a normal one, things fire that try to re-create the group before it switches to the non-group product line
            // We may want to say screw it and reset all OC data in Vuex on leave, but we'd still have to deal with pline to pline transitions
            if (!this.drill.isFitment) return

            // pre-select something (YMMBBE)
            if (this.currentValue != -1) {
                // dude, don't try to auto-select something that's not even in the list (ran into this when auto-selecting YMM where current Model wasn't in the list.. CYA)
                const found =
                    options.filter((obj) => {
                        return obj.value == this.currentValue
                    }).length > 0

                // It would be nice to not trigger an event when they have a bad auto-select and we set selectedValue = -1 (which hits the api and re-fills this control the the same crap it has)
                // It's a bit confusing as i want to just modify this.currentValue but Vue warns against it, but this is fine for now.
                if (found) this.selectedValue = this.currentValue
                else {
                    this.hasBadAutoSelect = true
                    this.selectedValue = -1
                }
            }
        },
    },
}
</script>

<style lang="stylus" scoped>
select[disabled]
    pointer-events: none
</style>
